import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSeatAssignment, getSettings } from '../utils/db';
import { SeatAssignment, SystemSettings } from '../types';

const SeatInfoPage: React.FC = () => {
  const { seatNumber } = useParams<{ seatNumber: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [assignment, setAssignment] = useState<SeatAssignment | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [settings, setSettings] = useState<SystemSettings>({ totalSeats: 30 });
  
  useEffect(() => {
    const fetchData = async () => {
      if (!seatNumber) {
        setError('席番号が指定されていません');
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        
        // システム設定を読み込む
        const settingsData = await getSettings();
        setSettings(settingsData);
        
        // 席番号を検証
        const seatNumberInt = parseInt(seatNumber, 10);
        if (isNaN(seatNumberInt)) {
          setError('無効な席番号です');
          setLoading(false);
          return;
        }
        
        // 席の割り当て情報を取得
        const result = await getSeatAssignment(seatNumberInt);
        if (!result) {
          setError('この席は現在割り当てられていません');
        } else {
          setAssignment(result);
        }
      } catch (err) {
        console.error('席情報の取得に失敗しました:', err);
        setError('席情報の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [seatNumber]);
  
  const handleReturnHome = () => {
    navigate('/');
  };
  
  return (
    <div className="seat-info-page">
      <div className="container">
        <header>
          <h1>席情報</h1>
        </header>
        
        <main>
          {loading ? (
            <div className="loading">読み込み中...</div>
          ) : error ? (
            <div className="error-container">
              <div className="error-message">{error}</div>
              <button onClick={handleReturnHome} className="return-button">
                ホームに戻る
              </button>
            </div>
          ) : assignment && (
            <div className="seat-info-container">
              <div className="user-info">
                <div className="user-name">{assignment.name} さん</div>
              </div>
              
              <div className="seat-info">
                <div className="seat-info-item">
                  <span className="label">席番号:</span>
                  <span className="value">{assignment.seatNumber}</span>
                </div>
              </div>
              
              <div className="actions">
                <button onClick={handleReturnHome} className="return-button">
                  ホームに戻る
                </button>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default SeatInfoPage; 